module.exports = __webpack_public_path__ + "static/media/que-hago.0531a055.svg";